"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var async_1 = require("./async");
var component_1 = require("./component");
/**
 * Clase para manejar los modales de una aplicación. Obtenga una referencia de la clase y llame a la función
 */
var ModalManager = /** @class */ (function (_super) {
    __extends(ModalManager, _super);
    function ModalManager(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Muestra un modal. Devuelve un promesa que se resuelve cuando el usuario cierra el modal con el valor del modal y el resultado de cerrado del modal
         * @param value Valor inicial del modal
         * @param component Componente que dibuja al modal
         */
        _this.showModal = function (component, params, value) {
            var oldList = _this.state.modals;
            var currentId = _this.state.nextId;
            var prom = async_1.splitPromise();
            var entry = {
                component: component,
                props: {
                    value: value,
                    params: params,
                    onChange: _this.handleOnChange(currentId),
                    onClose: _this.handleOnClose(currentId, prom.resolve)
                },
                id: currentId
            };
            //Agregamos el modal e incrementamos el id:
            _this.addEntry(entry);
            //Esta promesa se va a resolver cuando el usuario cierre el modal
            return prom.promise;
        };
        _this.handleOnClose = function (id, resolve) { return function (result) {
            //Llamamos al resolve
            resolve({ value: _this.getValue(id), result: result });
            //Quitamos la entrada
            _this.removeEntry(id);
        }; };
        /**Obtiene el valor de un modal */
        _this.getValue = function (id) {
            var oldList = _this.state.modals;
            return oldList.filter(function (x) { return x.id == id; })[0].props.value;
        };
        /**Recibe el cambio del valor de un modal */
        _this.handleOnChange = function (id) { return function (value) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var oldList, newList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldList = this.state.modals;
                        newList = oldList.map(function (x) { return x.id == id ? __assign({}, x, { props: __assign({}, x.props, { value: value }) }) : x; });
                        return [4 /*yield*/, new Promise(function (resolve) { return _this.setState({ modals: newList }, resolve); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }; };
        _this.state = {
            modals: [],
            nextId: 0
        };
        return _this;
    }
    ModalManager.prototype.removeEntry = function (id) {
        this.setState(function (prev) { return ({ modals: prev.modals.filter(function (x) { return x.id != id; }) }); });
    };
    /**Agrega una entrada de modal e incrementa el id */
    ModalManager.prototype.addEntry = function (entry) {
        this.setState(function (prev) { return ({ modals: __spread(prev.modals, [entry]), nextId: prev.nextId + 1 }); });
    };
    ModalManager.prototype.render = function () {
        return React.createElement(component_1.ModalManagerComponent, __assign({}, this.state));
    };
    return ModalManager;
}(React.PureComponent));
exports.ModalManager = ModalManager;
//# sourceMappingURL=manager.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-modal-manager/dist/manager.js
// module id = 2487
// module chunks = 0